exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@charset \"UTF-8\";\n.container[data-v-9dcd87c8] {\n  background-color: #f4f4f4;\n  padding: 10px;\n}\n.container[data-v-9dcd87c8] .tips {\n    position: relative;\n    /** 伪元素 */\n}\n.container[data-v-9dcd87c8] .tips .tips-content {\n      position: absolute;\n      top: 25%;\n      left: -104%;\n      color: #afaeae;\n}\n.container[data-v-9dcd87c8] .tips .tips-content2 {\n      position: absolute;\n      top: 25%;\n      left: -65%;\n      color: #afaeae;\n}\n", ""]);

// exports
